import { render } from "./Examen.vue?vue&type=template&id=2cdc2657"
import script from "./Examen.vue?vue&type=script&lang=js"
export * from "./Examen.vue?vue&type=script&lang=js"

import "./Examen.vue?vue&type=style&index=0&id=2cdc2657&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__